import React from 'react';
import PropTypes from 'prop-types';

import themeable from 'zignal-landscape/lib/themeable';
import Add3Icon from 'zignal-landscape/lib/Icon/Add3Icon';

const ZccAdd = ({styles, onNewClick}) => {

  return (
    <div className={styles.ZccAdd}>
      <a onClick={onNewClick} className={styles.addButton}><Add3Icon /> Add Command Center</a>
    </div>
  );
};

ZccAdd.propTypes = {
  styles: PropTypes.object,
  onNewClick: PropTypes.func
};

export default themeable(ZccAdd);
